document.addEventListener("alpine:init", () => {
    Alpine.data("stickyCTA", () => ({
        scrolled: false,
        visible: true,
        init() {},
        stickyScrolling() {
            const navigationContainer = document.getElementById("sticky-cta"),
                navigationHeight = navigationContainer.offsetHeight;

            this.scrolled = window.scrollY >= navigationHeight;

            let st = window.scrollY;

            if (st >= this.lastScrollTop) {
                //Scroll Down
                if (st >= navigationHeight) {
                    navigationContainer.classList.remove("translate-y-full");
                    this.visible = true;
                } else {
                    navigationContainer.classList.add("translate-y-full");
                    this.visible = false;
                }
            } else {
                //Scroll Up
                navigationContainer.classList.add("translate-y-full");
                this.visible = false;
            }

            this.lastScrollTop = st;
        },
    }));
});
